import { createSlice } from "@reduxjs/toolkit";
import { Company } from "../../company-page/store/slice";
import { Role, User } from "../../users/store/slice";

export type Profile = Omit<User, "roles" | "companies"> & {
  roles: Role[];
  companies: Company[];
};

type InitialState = {
  isLoggedIn: boolean;
  isLoading: boolean;
  profile: Profile | null;
};

const initialState: InitialState = {
  isLoggedIn: false,
  isLoading: false,
  profile: null,
};

const loginPageSlice = createSlice({
  name: "loginPageSlice",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoading = true;
    },
    autoLogin: (state) => {
      state.isLoading = true;
    },
    logout: (state) => {
      state.isLoading = true;
    },
    revokeToken: (state) => {
      //
    },
    setLoggedIn: (state, action) => {
      state.profile = action.payload;
      state.isLoggedIn = true;
      state.isLoading = false;
    },
    setLoggedOut: (state) => {
      state.isLoggedIn = false;
      state.isLoading = false;
      state.profile = null;
    },
    reset: () => initialState,
  },
});

export default loginPageSlice;
